/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PowerGenerationRevenue.vue?vue&type=template&id=6b04cfaa&"
import script from "./PowerGenerationRevenue.vue?vue&type=script&lang=js&"
export * from "./PowerGenerationRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports